// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoRecurrence_wrapper__1cC6-","selected":"InfoRecurrence_selected__1DR_B","day":"InfoRecurrence_day__2NfC6"};